export default __webpack_public_path__ + "static/media/One.442fa4d6.svg";